var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLandingPagesCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Desktop-Chat--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Desktop Chat Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-chat--bubble-chat-customer-service-conversation-display-device"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M5.429 4.648a1 1 0 0 0 1 1h2.214v1.208a0.5 0.5 0 0 0 0.777 0.416l2.437 -1.624H13a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1H6.429a1 1 0 0 0 -1 1v3.648ZM8.515 11H12.5A1.5 1.5 0 0 0 14 9.5V8a1 1 0 1 0 -2 0v1H2V3h1a1 1 0 0 0 0 -2H1.5A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-0.537 1.5H4A0.75 0.75 0 0 0 4 14h6a0.75 0.75 0 0 0 0 -1.5h-0.948L8.515 11Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLandingPagesCurrent);
export default __webpack_public_path__ + "static/media/menu-landing-pages-current.aad88bb4e2e86a87d48f69bb2d491e30.svg";
export { ForwardRef as ReactComponent };